import { Badge } from '@systemeio/components'
import { useState } from 'react'
import { Loader } from 'shared/components/loader'
import { twJoin } from 'tailwind-merge'

interface HeaderCounterProps {
  count?: number
}

export function HeaderCounter({ count }: HeaderCounterProps) {
  const isLoading = count === undefined
  const [lastCount, setLastCount] = useState(count)
  if (count !== undefined && count !== lastCount) setLastCount(count)

  return (
    <Badge shape="pill" size="lg" color="darkGray" aria-busy={isLoading}>
      {/* Keep the number's width while the loader overlays it. */}
      <span
        className={twJoin('min-w-4 text-center tabular-nums', isLoading && 'invisible')}
        aria-hidden={isLoading}
      >
        {isLoading ? (lastCount ?? 0) : count}
      </span>
      {isLoading && (
        <Loader small type="dark" className="absolute inset-0 flex items-center justify-center" />
      )}
    </Badge>
  )
}
